import { AdvancedSettings } from "./AdvancedSettings.model";

export class EvaluationFrontendParameter{
    projectId: number;
    travelMixList: number[];
    graphicList: number[];
    considerAllDecksForCalculation: boolean;
    advancedSettings: AdvancedSettings;
}